import { useEffect } from 'react';

export function ServiceWorkerRegistration() {
  useEffect(() => {
    // Remove this component since Vite PWA plugin handles service worker registration
    // The service worker registration is already handled by registerSW.js generated by Vite PWA
    console.log('Service worker registration is handled by Vite PWA plugin');
  }, []);

  return null;
}
